// var productCardMarkup = `
//   <div class="swym-wishlist-grid">
// 		{{#products}}
//     <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor"><button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"><span class="swym-icon"></span></button>
// 		<div class="swym-wishlist-image-wrapper"><img alt="" class="swym-wishlist-image" src="{{iu}}"></div><button class="swym-is-button">
// 		<div class="swym-title swym-title-1">
// 			{{dt}}
// 		</div></button>
// 		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
// 			{{variantinfo}}
// 		</div>
// 		<div class="swym-product-price swym-text swym-text-1">
// 			<div class="swym-product-final-price swym-value">
// 				{{cu}}{{pr}}
// 			</div>
//         </div>
// 		<button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}"data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}"class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
// 			{{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
// 		</button>
//     </a>
//       {{/products}}
// 	</div>
//   `;

var productCardMarkup = `
  <div class="swym-wishlist-grid">
		{{#products}}
    <div class="wishlist__product">
      <div class="wishlist__product-wrap">
        <div class="swym-wishlist-image-wrapper">
          <img alt="Wishlist Product image" src="{{iu}}" class="product-image" link-to-product="{{du}}">
        </div>
        <div class="product-description-container">
          <div class="wishlist__product__title-container">
            <a href="{{du}}" class="wishlist__product__title">{{dt}}</a>
          </div>
          <div class="swym-product-final-price">
            <p class="wishlist__product__description">{{cu}}{{pr}}</p>
          </div>
          <div class="wishlist__product-footer">
            <div class="wishlist__product-cart">
              <button data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="button submit-button add-to-cart-btn">
              {{#isInCart}}ADDED TO BAG{{/isInCart}}{{^isInCart}}ADD TO BAG{{/isInCart}}
              </button>
            </div>
            <div class="remove-btn-container">
              <a href="#" class="wishlist__product__remove remove-product-btn" data-variant-id="{{epi}}" data-product-id="{{empi}}">REMOVE</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    {{/products}}
	</div>
  `;

function getVariantInfo(variants) {
  try {
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []),
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    var noProducts = document.getElementById("wishlist-no-products");
    if (products == 0) {
      console.log('no products');
      noProducts.classList.remove("wishlist-no-items--hidden");
    } else {
      console.log('some products');
      noProducts.classList.add("wishlist-no-items--hidden");
    }
    console.log(products)
    var wishlistContentsContainer = document.getElementById("wishlist-items-container");
    var formattedWishlistedProducts = products.map(function (p) {
      // old format of money: '$4200,00'
      //p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.cu = "$";
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
      p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts
    });
    wishlistContentsContainer.innerHTML = productCardsMarkup;
    attachClickListeners();
  });
}

function onAddToCartClick(e) {
  e.preventDefault();
  var event = e;
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  event.target.innerHTML = "Adding..";
  window._swat.replayAddToCart({
    empi: productId,
    du: du
  }, variantId, function (c) {    // success
    event.target.innerHTML = "Added to Bag";
    event.target.setAttribute("data-state-cart", "swym-added");
    updateCartCount('link-cart__number');
  }, function (e) {               // fail
    if(e === 'Variant is in stock')
      event.target.innerHTML = "Out of stock";
    else
      event.target.innerHTML = "Unavailable";
  });
}

const updateCartCount = (cartCountElClassName) => {
  let cartCount = document.getElementsByClassName(cartCountElClassName)[0].textContent;   // get cartCount html element value
  let intCartCount = parseInt(cartCount, 10);                                             // transform it to a number
  document.getElementsByClassName(cartCountElClassName)[0].innerHTML = intCartCount + 1;  // update it
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  })
}

const onProductImageClick = (e) => {
  e.preventDefault();
  let linkToProduct = e.currentTarget.getAttribute("link-to-product");
  console.log(linkToProduct);
  location.href = linkToProduct;
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(".add-to-cart-btn");
  var removeBtns = document.querySelectorAll(".remove-product-btn");
  var productImgs = document.querySelectorAll(".product-image");

  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }

  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log("Events attached!");

  // Product Images
  for (var j = 0; j < productImgs.length; j++) {
    productImgs[j].addEventListener('click', onProductImageClick, false);
  }
}